import React from 'react';

/** Placeholder gym illustration from workout-edit-v2.html (hero left panel). */
export function HeroBannerPlaceholderSvg() {
  return (
    <svg className="bg" viewBox="0 0 600 400" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <defs>
        <linearGradient id="twe-floor" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--ink)" />
          <stop offset="100%" stopColor="var(--ink)" />
        </linearGradient>
        <linearGradient id="twe-rack" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--text-secondary)" />
          <stop offset="100%" stopColor="var(--ink)" />
        </linearGradient>
        <linearGradient id="twe-glow" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--action-primary)" stopOpacity="0.4" />
          <stop offset="100%" stopColor="var(--action-primary)" stopOpacity="0" />
        </linearGradient>
      </defs>
      <rect x="0" y="280" width="600" height="120" fill="url(#twe-floor)" />
      <rect x="0" y="0" width="600" height="280" fill="var(--ink)" />
      <ellipse cx="450" cy="140" rx="200" ry="120" fill="url(#twe-glow)" opacity="0.5" />
      <g opacity="0.9">
        <path d="M 60 280 L 60 160 L 540 160 L 540 280 Z" fill="url(#twe-rack)" />
        <line x1="60" y1="200" x2="540" y2="200" stroke="var(--ink)" strokeWidth="2" />
        <line x1="60" y1="240" x2="540" y2="240" stroke="var(--ink)" strokeWidth="2" />
        <g>
          <circle cx="100" cy="180" r="14" fill="var(--ink)" stroke="var(--text-secondary)" />
          <rect x="110" y="174" width="22" height="12" fill="var(--ink)" stroke="var(--text-secondary)" />
          <circle cx="142" cy="180" r="14" fill="var(--ink)" stroke="var(--text-secondary)" />
          <circle cx="180" cy="180" r="13" fill="var(--ink)" stroke="var(--text-secondary)" />
          <rect x="189" y="174" width="20" height="12" fill="var(--ink)" stroke="var(--text-secondary)" />
          <circle cx="219" cy="180" r="13" fill="var(--ink)" stroke="var(--text-secondary)" />
          <circle cx="255" cy="180" r="12" fill="var(--ink)" stroke="var(--text-secondary)" />
          <rect x="263" y="174" width="18" height="12" fill="var(--ink)" stroke="var(--text-secondary)" />
          <circle cx="289" cy="180" r="12" fill="var(--ink)" stroke="var(--text-secondary)" />
        </g>
        <g>
          <circle cx="105" cy="222" r="16" fill="var(--ink)" stroke="var(--text-secondary)" />
          <rect x="116" y="214" width="24" height="16" fill="var(--ink)" stroke="var(--text-secondary)" />
          <circle cx="150" cy="222" r="16" fill="var(--ink)" stroke="var(--text-secondary)" />
          <circle cx="195" cy="222" r="15" fill="var(--ink)" stroke="var(--text-secondary)" />
          <rect x="205" y="214" width="22" height="16" fill="var(--ink)" stroke="var(--text-secondary)" />
          <circle cx="237" cy="222" r="15" fill="var(--ink)" stroke="var(--text-secondary)" />
          <circle cx="280" cy="222" r="14" fill="var(--ink)" stroke="var(--text-secondary)" />
          <rect x="289" y="214" width="20" height="16" fill="var(--ink)" stroke="var(--text-secondary)" />
          <circle cx="318" cy="222" r="14" fill="var(--ink)" stroke="var(--text-secondary)" />
        </g>
      </g>
    </svg>
  );
}

/** Placeholder video tile art from workout-edit-v2.html. */
export function VideoTilePlaceholderSvg({ idSuffix }: { idSuffix: string }) {
  const gradId = `twe-vg-${idSuffix}`;
  return (
    <svg className="bg" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <defs>
        <radialGradient id={gradId} cx="50%" cy="40%" r="60%">
          <stop offset="0%" stopColor="var(--text-secondary)" />
          <stop offset="100%" stopColor="var(--ink)" />
        </radialGradient>
      </defs>
      <rect width="200" height="150" fill={`url(#${gradId})`} />
      <rect x="60" y="70" width="80" height="6" fill="var(--ink)" />
      <rect x="64" y="76" width="5" height="28" fill="var(--ink)" />
      <rect x="131" y="76" width="5" height="28" fill="var(--ink)" />
      <circle cx="50" cy="72" r="10" fill="var(--ink)" stroke="var(--text-secondary)" />
      <circle cx="150" cy="72" r="10" fill="var(--ink)" stroke="var(--text-secondary)" />
    </svg>
  );
}

export function VideoReplaceOverlay() {
  return (
    <div className="replace-overlay">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <polyline points="17 1 21 5 17 9" />
        <path d="M3 11V9a4 4 0 0 1 4-4h14" />
        <polyline points="7 23 3 19 7 15" />
        <path d="M21 13v2a4 4 0 0 1-4 4H3" />
      </svg>
      Replace video
    </div>
  );
}
